export interface ChangeLogEntry {
  date: string;
  version?: string;
  items: string[];
}

// Newest first: the toast announces CHANGELOG[0].
export const CHANGELOG: ChangeLogEntry[] = [
  {
    date: '2026-10-21',
    version: '1.7.1',
    items: [
      'Support Portal has moved to Agency Management in the left nav, right under My Agency.',
    ],
  },
  {
    date: '2026-10-20',
    version: '1.7.0',
    items: [
      'The location of support options has changed to the top right corner of AgencyOS. Same options, new spot.',
    ],
  },
  {
    date: '2026-10-05',
    version: '1.6.0',
    items: [
      'Ask AgencyOS — our new assistant, now in the left nav. Ask questions about anything currently on AgencyOS, including the contents of articles, and find the information you need sooner.',
    ],
  },
  {
    date: '2026-08-18',
    version: '1.5.1',
    items: [
      'Canva AI Prompts now available in Corporate Connect → Marketing → Canva — get AI prompt guidance for creating marketing content',
    ],
  },
  {
    date: '2026-06-30',
    version: '1.5.0',
    items: [
      'Insurance news is live on the home page — stay up to date with the latest industry news and updates',
    ],
  },
  {
    date: '2026-06-18',
    version: '1.4.1',
    items: [
      'Upload JPG, PNG, or GIF photos for your headshot — all photos are saved automatically',
      'Attachments that fail to upload won\'t stop your ticket from being submitted — we\'ll let you know if something didn\'t attach',
      'Mortgage/Lienholder request and Commercial Certificate forms now available in Agency Operations',
    ],
  },
  {
    date: '2026-06-12',
    version: '1.4.0',
    items: [
      'New "Corporate Connect" menu — Accounting, Support Portal, Key Contacts, Marketing, and Technology are now grouped together in the left nav for easier access',
      'Kudos cards are now click-to-open — tap anywhere on a card to read the full message',
    ],
  },
  {
    date: '2026-06-08',
    version: '1.3.0',
    items: [
      'Kudos Wall — recognize corporate team members directly from the home page',
      'Agency Pages — click any agency in the Agent Directory to preview their public page',
      'Multi-location support — owners see all child locations on My Agency',
      'Website Bio — agency owners can now write and edit their weinsuregroup.com bio',
      'Hidden staffers (silent partners) no longer appear on public-facing displays',
    ],
  },
  {
    date: '2026-06-01',
    version: '1.2.1',
    items: [
      'Equipment Ordering now shows model numbers and estimated delivery dates',
      'Added Branch field to user profiles for agency association',
      'Business Cards and Email Signatures added to Marketing Resources',
    ],
  },
  {
    date: '2026-05-28',
    version: '1.2.0',
    items: [
      'Navigation sidebar is now collapsible for more screen space',
      'Jira ticket descriptions now visible in the support portal',
    ],
  },
  {
    date: '2026-05-19',
    version: '1.1.0',
    items: [
      'Chat box now pops out for easier access to support',
      'Statuspage now available for real-time updates on IT issues and maintenance',
      'Added My Support Requests page — view open tickets, comments, and reply directly',
      'Added new IT Support form with improved user experience',
      'Recent searches shown when clicking the search bar',
    ],
  },
  {
    date: '2026-05-12',
    version: '1.0.1',
    items: [
      'Enabled attachment upload for jira ticket submissions',
      'Launch of AgencyOS',
    ],
  },
];
